module.exports = __webpack_public_path__ + "img/half_red.606a7e08.png";